import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import {
  CRUDLayout,
  Alert,
  DataStatus,
  ActionButton,
  ReadButton,
  UpdateButton,
  InputSearch,
  Pagination,
  Table,
  THead,
  TBody,
  Tr,
  ThFixed,
  TdFixed,
  Th,
  Td,
  FilterButton,
  ApprovalStatusButton,
} from 'components';
import { DateConvert, PageNumber as TableNumber } from 'utilities';
import { SuratPerjanjianKerjaApi } from 'api';
import { useIsGuest } from 'hooks';
import { ModalFilter } from './Section';

const SPK = ({ setNavbarTitle }) => {
  const history = useHistory();
  const location = useLocation();
  const isGuest = useIsGuest();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [dataSPK, setDataSPK] = useState([]);
  const [showModalFilter, setShowModalFilter] = useState(false);
  const [dataFilter, setDataFilter] = useState({
    filter: {
      active: location?.state?.spk?.filter?.active,
      tgl_spk_mulai: location?.state?.spk?.filter?.tgl_spk_mulai,
      tgl_spk_selesai: location?.state?.spk?.filter?.tgl_spk_selesai,
      customer: location?.state?.spk?.filter?.customer,
      proyek: location?.state?.spk?.filter?.proyek,
      realisasi_penawaran_mulai:
        location?.state?.spk?.filter?.realisasi_penawaran_mulai,
      realisasi_penawaran_selesai:
        location?.state?.spk?.filter?.realisasi_penawaran_selesai,
    },
    pagination: {
      page: location?.state?.spk?.filter?.page ?? '1',
      dataLength: location?.state?.spk?.filter?.dataLength ?? '10',
      totalPage: location?.state?.spk?.filter?.totalPage ?? '1',
      dataCount: location?.state?.spk?.filter?.dataCount ?? '0',
    },
  });
  const [searchConfig, setSearchConfig] = useState({
    status: false,
    key: '',
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: 'primary',
    text: '',
  });

  const getInitialData = () => {
    setIsPageLoading(true);

    SuratPerjanjianKerjaApi.get({
      q: searchConfig.key,
      page: dataFilter?.pagination?.page,
      per_page: dataFilter?.pagination?.dataLength,
      tgl_spk_mulai: dataFilter?.filter?.tgl_spk_mulai,
      tgl_spk_selesai: dataFilter?.filter?.tgl_spk_selesai,
      customer: dataFilter?.filter?.customer,
      proyek: dataFilter?.filter?.proyek,
      realisasi_penawaran_mulai: dataFilter?.filter?.realisasi_penawaran_mulai,
      realisasi_penawaran_selesai:
        dataFilter?.filter?.realisasi_penawaran_selesai,
    })
      .then((data) => {
        setDataSPK(data?.data?.data ?? []);
        setDataFilter({
          ...dataFilter,
          pagination: {
            ...dataFilter.pagination,
            dataCount: data?.data?.data_count,
            totalPage: data?.data?.total_page,
          },
        });
      })
      .catch((err) => {
        setAlertConfig({
          show: true,
          variant: 'danger',
          text: 'Data gagal dimuat!',
        });
      })
      .finally(() => setIsPageLoading(false));
  };

  const checkAlert = () => {
    const locationState = location.state;

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant,
        });
      }
    }
  };

  const dismissAlert = () => {
    setAlertConfig({ show: false, variant: 'primary', text: '' });

    const locationState = location.state;
    let state = { ...locationState };
    delete state.alert;
    history.replace({ ...state });
  };

  const onInputSearchChange = (e) => {
    const key = e.target.value;

    setSearchConfig({
      ...searchConfig,
      key: e.target.value,
    });
    setDataFilter({
      ...dataFilter,
      pagination: {
        ...dataFilter.pagination,
        page: '1',
        dataLength: '10',
        totalPage: '1',
        dataCount: '0',
      },
    });
    setAlertConfig({
      show: key ? true : false,
      variant: 'primary',
      text: 'Hasil dari pencarian: ' + key,
    });
  };

  useEffect(() => {
    setNavbarTitle('Surat Perjanjian Kerja (SPK)');
    getInitialData();
    checkAlert();

    return () => {
      setIsPageLoading(false);
    };
  }, [
    setNavbarTitle,
    searchConfig.key,
    dataFilter?.pagination?.page,
    dataFilter?.pagination?.dataLength,
    dataFilter?.filter?.active,
    dataFilter?.filter?.tgl_spk_mulai,
    dataFilter?.filter?.tgl_spk_selesai,
    dataFilter?.filter?.customer,
    dataFilter?.filter?.proyek,
    dataFilter?.filter?.realisasi_penawaran_mulai,
    dataFilter?.filter?.realisasi_penawaran_selesai,
  ]);

  const BarangJadiCollapse = ({ data }) => {
    const [isReadMoreClick, setisReadMoreClick] = useState(false);

    return (
      <>
        <ul className="pl-3 mb-1" style={{ fontSize: '12px' }}>
          {data.map((brg, index) => {
            if (isReadMoreClick) {
              return <li index={index}>{brg.nama_item}</li>;
            } else {
              return index <= 2 && <li index={index}>{brg.nama_item}</li>;
            }
          })}
        </ul>
        {data.length <= 2 ? (
          ''
        ) : (
          <div
            className="text-primary"
            style={{
              cursor: 'pointer',
              textDecoration: 'underline',
              // fontWeight: "bold",
            }}
            onClick={() => {
              setisReadMoreClick((prev) => !prev);
            }}
          >
            {isReadMoreClick ? 'Sembunyikan' : 'Selengkapnya...'}
          </div>
        )}
      </>
    );
  };

  const PageContent = () => {
    const checkStatus = (stat) => {
      const data = stat ? stat.toUpperCase() : '';
      const convert = data.substring(0, 3);

      if (convert === 'APP')
        return {
          variant: 'outline-success',
          label: 'APPROVED',
        };
      if (convert === 'VER')
        return {
          variant: 'outline-success',
          label: 'VERIFIED',
        };
      if (convert === 'REV')
        return {
          variant: 'outline-warning',
          label: 'REVISION',
        };
      if (convert === 'REJ')
        return {
          variant: 'outline-danger',
          label: 'REJECTED',
        };

      return {
        variant: 'outline-secondary',
        label: 'PENDING',
      };
    };

    const checkEditButton = (status) => {
      const stat = checkStatus(status).label;

      if (
        stat.toUpperCase() === 'REVISION' ||
        stat.toUpperCase() === 'APPROVED'
      )
        return true;

      return false;
    };

    const DataTable = () => (
      <>
        <span style={{ fontSize: '14px' }}>
          <b>List Data Surat Perjanjian Kerja (SPK)</b>
        </span>
        <Table>
          <THead>
            <Tr>
              <ThFixed>No</ThFixed>
              <ThFixed>Aksi</ThFixed>
              <ThFixed>Informasi SPK</ThFixed>
              <Th>Customer</Th>
              <Th>Proyek</Th>
              <Th>ATT</Th>
              <ThFixed>Tgl. Realisasi Penawaran</ThFixed>
              <Th>Barang Jadi</Th>
              <ThFixed>Baseline</ThFixed>
              <ThFixed>Status Approval</ThFixed>
            </Tr>
          </THead>
          <TBody>
            {dataSPK.map((val, index) => (
              <Tr key={index}>
                <TdFixed textCenter>
                  {TableNumber(
                    dataFilter?.pagination?.page,
                    dataFilter?.pagination?.dataLength,
                    index
                  )}
                </TdFixed>
                <TdFixed>
                  <div className="d-flex">
                    <ReadButton
                      onClick={() =>
                        history.push('/transaksi/spk/detail/' + val.id_spk, {
                          status_approval: val.status_approval,
                          ...location?.state,
                          spk: dataFilter,
                        })
                      }
                    />
                    {checkEditButton(val.status_approval) && (
                      <UpdateButton
                        onClick={() =>
                          history.push('/transaksi/spk/ubah/' + val.id_spk, {
                            ...location?.state,
                            spk: dataFilter,
                          })
                        }
                      />
                    )}
                  </div>
                </TdFixed>
                <TdFixed>
                  <div>
                    {val.tgl_spk
                      ? DateConvert(new Date(val.tgl_spk)).custom
                      : '-'}
                  </div>
                  <div>{val.no_spk ? val.no_spk : '-'}</div>
                </TdFixed>
                <Td style={{ minWidth: '280px' }}>
                  {val.nama_customer ? val.nama_customer : '-'}
                </Td>
                <Td style={{ minWidth: '280px' }}>{val.nama_proyek ?? '-'}</Td>
                <Td style={{ minWidth: '280px' }}>{val.att ? val.att : '-'}</Td>
                <TdFixed>
                  {val.realisasi_penawaran
                    ? DateConvert(new Date(val.realisasi_penawaran)).custom
                    : '-'}
                </TdFixed>
                <Td style={{ minWidth: '300px' }}>
                  {val.barang_jadi ? (
                    val.barang_jadi.length > 0 ? (
                      <BarangJadiCollapse data={val.barang_jadi} />
                    ) : (
                      '-'
                    )
                  ) : (
                    '-'
                  )}
                </Td>
                <TdFixed textCenter>
                  {val.baseline ? val.baseline : '-'}
                </TdFixed>
                <TdFixed>
                  <ApprovalStatusButton
                    variant={checkStatus(val.status_approval).variant}
                  >
                    {checkStatus(val.status_approval).label}
                  </ApprovalStatusButton>
                </TdFixed>
              </Tr>
            ))}
          </TBody>
        </Table>
      </>
    );

    if (!dataSPK || dataSPK.length < 1) {
      return <DataStatus text="Tidak ada data" />;
    }

    return (
      <>
        <DataTable />
        {!searchConfig.status && (
          <Pagination
            dataLength={dataFilter?.pagination?.dataLength}
            dataNumber={
              dataFilter?.pagination?.page *
                dataFilter?.pagination?.dataLength -
              dataFilter?.pagination?.dataLength +
              1
            }
            dataPage={
              dataFilter?.pagination?.dataCount <
              dataFilter?.pagination?.dataLength
                ? dataFilter?.pagination?.dataCount
                : dataFilter?.pagination?.page *
                  dataFilter?.pagination?.dataLength
            }
            dataCount={dataFilter?.pagination?.dataCount}
            currentPage={dataFilter?.pagination?.page}
            totalPage={dataFilter?.pagination?.totalPage}
            onPaginationChange={({ selected }) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: selected + 1,
                },
              })
            }
            onDataLengthChange={(e) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: 1,
                  dataLength: e.target.value,
                },
              })
            }
          />
        )}
      </>
    );
  };

  return (
    <CRUDLayout>
      {/* head section */}
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch
              value={searchConfig.key}
              onChange={onInputSearchChange}
            />
            <FilterButton
              active={dataFilter?.filter?.active}
              onClick={() => setShowModalFilter(true)}
            />
          </div>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection>
          {!isGuest && (
            <ActionButton
              text="Tambah Data"
              onClick={() =>
                history.push('/transaksi/spk/penawaran', {
                  ...location?.state,
                  spk: dataFilter,
                })
              }
            />
          )}
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* alert */}
      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() => dismissAlert()}
      />

      {/* content */}
      {isPageLoading ? (
        <DataStatus loading={true} text="Memuat data . . ." />
      ) : (
        <PageContent />
      )}

      {showModalFilter && (
        <ModalFilter
          show={showModalFilter}
          setShow={setShowModalFilter}
          data={dataFilter}
          setData={setDataFilter}
        />
      )}
    </CRUDLayout>
  );
};

export default SPK;
